import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Building2, Users, Handshake, BarChart3, Plug } from 'lucide-react';

interface CrmSubNavProps {
  active: 'negocios' | 'contas' | 'contatos' | 'relatorios' | 'integracoes';
  /** Seletor de empresa (superadmin) — renderizado à direita, fora do fluxo dos itens de navegação. */
  right?: ReactNode;
}

const ITEMS = [
  { key: 'negocios' as const, label: 'Negócios', url: '/crm', icon: Handshake },
  { key: 'contas' as const, label: 'Contas', url: '/crm/contas', icon: Building2 },
  { key: 'contatos' as const, label: 'Contatos', url: '/crm/contatos', icon: Users },
  { key: 'relatorios' as const, label: 'Relatórios', url: '/crm/relatorios', icon: BarChart3 },
  { key: 'integracoes' as const, label: 'Integrações', url: '/crm/integracoes', icon: Plug },
];

export function CrmSubNav({ active, right }: CrmSubNavProps) {
  return (
    <div className="flex items-center justify-between gap-1 border-b pb-2">
      <div className="flex items-center gap-1">
        {ITEMS.map((item) => (
          <Link
            key={item.key}
            to={item.url}
            className={cn(
              'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
              active === item.key
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </Link>
        ))}
      </div>
      {right}
    </div>
  );
}
